export default {
  // ConfirmModal 组件
  confirmModal: {
    title: "Verify your business",
    description:
      "To expedite the review of your campaign, please provide a work email address to verify your business.",
    workEmailLabel: "Work email",
    emailPlaceholder: "Please enter your email",
    emailValidationMessage: "Please enter a business email address",
    emailError: "Please enter a business email address",
    noWorkEmailText: "Do not have a work email?",
    clickHere: "Click here",
    sendEmailText:
      "to send us an email with any business or partnership document as an agency. You can also contact us directly via",
    back: "Back",
    continue: "Continue",
    emailSentTitle: "Verify your business",
    emailSentDescription: "We've sent an email to",
    emailSentCodeDescription:
      "containing a 6-digit code which expires in 10 minutes. Please enter it below.",
    resendIn: "Resend in",
    resendText: "Didn't receive the email.",
    resend: "Resend",
    contactUs: "If you need any assistance, don't hesitate to",
    contactUsLink: "contact us.",
  },

  // AdsGuideModal 组件
  adsGuideModal: {
    // 通用
    title: "Aha Instructions",
    description:
      "Get an overview of essentials of Aha to help you maximize your success",
    close: "Close",
    next: "Next",
    previous: "Back",
    skip: "Skip",
    finish: "Complete",

    // Step1
    step1: {
      title: "Welcome to Ads Guide",
      description: "Let's get started with your advertising journey",
      startButton: "Get Started",
      tips: "Tips",
      influencerContact:
        "Some influencers may contact you to confirm your partnership with Aha. Simply respond to them and verify it. Please try to avoid further offline contact, as the lack of platform oversight could harm your interests.",
      promptlyApproving: "Promptly approving applications",
      promptlyApprovingDescription:
        "helps secure influencers' schedules and enhances collaboration success rates, while delayed feedback increases the risk of influencer ghosting.",
      headFollowUp:
        "Aha actively follows up with influencers, lowering the default rate from 30–40% (industry level) to ~20%. However, we still",
      recommendExtraInfluencers: "recommend approving extra influencers",
      recommendExtraInfluencersDescription:
        "to ensure full budget delivery, as defaults are fully refundable.",
    },

    // Step2
    step2: {
      title: "Choose Your Platform",
      description: "Select the platform where you want to advertise",
      platform: "Platform",
      selectPlatform: "Select a platform",
      aiAgentsPolicy:
        "Aha agents have enforced strict policies for influencers. Please report influencers using the report feature if you still encounter any who violate Aha platform standards.",
      tips: "Tips",
    },

    // Step3
    step3: {
      title: "Set Your Budget",
      description: "Define your advertising budget",
      budget: "Budget",
      setBudget: "Set your budget",
    },

    // Step5
    step5: {
      title: "Target Audience",
      description: "Define your target audience",
      audience: "Audience",
      demographics: "Demographics",
      interests: "Interests",
      location: "Location",
      noSampleShipment: "No sample shipment",
      withSampleShipment: "With sample shipment",
      dedicatedVideo: "Dedicated video",
      integratedVideo: "Integrated video",
      tips: "Tips",
    },

    // Step6
    step6: {
      title: "Review & Launch",
      description: "Review your campaign settings before launching",
      review: "Review",
      launch: "Launch Campaign",
      settings: "Campaign Settings",
      keyRequirements: "Key requirements",
      requirementsDescription:
        "Provide feedback to influencers based on the following requirements to drive conversions",
    },

    // PlatformsTab
    platformsTab: {
      facebook: "Facebook",
      instagram: "Instagram",
      google: "Google Ads",
      tiktok: "TikTok",
      youtube: "YouTube",
      twitter: "X (Twitter)",
      linkedin: "LinkedIn",
    },

    // 营销策略
    marketing: {
      influencer: "Influencer marketing",
      affiliate: "Affiliate marketing",
    },

    // 步骤项目
    items: {
      aiAgents: "What AI agents will do next",
      platformGuarantee: "Platform guarantee",
      noResultsNoPayment: "No results, No Payment",
      deliveryTimelines: "Delivery timelines",
      contentRequirements: "Aha's content requirements",
    },

    // 配置相关
    config: {
      // Step5 配置
      step5: {
        promptFeedback: "Prompt feedback",
        promptFeedbackDescription:
          "to the influencers often drive more efficient collaboration and better campaign results",
      },

      // Step6 配置
      step6: {
        youtube: {
          cta: "CTA",
          ctaDescription:
            "Place the CTA at the most engaging point in your video to capture viewer interest effectively",
          description: "Description",
          descriptionText:
            "Use a strong call-to-action for promotion at the beginning of description. Ensure CTA and link are visible even when collapsed.",
          videoLength: "Video length",
          videoLengthText:
            "Ensure the overall video length is at least 5 minutes",
          headProvidedLink: "Aha-Provided Link",
          headProvidedLinkText:
            "Use the promotional link provided by Aha, not the official website link or a redirected link.",
          platformRequirements:
            "Check platform requirements for full requirements",
        },
        tiktok: {
          endingCta: "Ending CTA",
          endingCtaDescription:
            'Prompt viewers in speech and with caption at the end of the video. E.g., "Tap the link in bio for more info!"',
          caption: "Caption",
          captionDescription:
            'Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"',
          linkInBio: "Link in bio",
          linkInBioDescription:
            "The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.",
          headProvidedLink: "Aha-Provided Link",
          headProvidedLinkText:
            "Use the promotional link provided by Aha, not the official website link or a redirected link.",
          platformRequirements:
            "Check platform requirements for full requirements",
        },
        twitter: {
          endingCta: "Ending CTA",
          endingCtaDescription:
            'If you are posting a video, prompt viewers in speech and with caption at the end of the video. E.g., "Visit the link in our tweet for more info!"',
          caption: "Caption",
          captionDescription:
            'Post with a strong CTA in the caption, like: "Check out more: {link}🌟"',
          headProvidedLink: "Aha-Provided Link",
          headProvidedLinkText:
            "Use the promotional link provided by Aha, not the official website link or a redirected link.",
          platformRequirements:
            "Check platform requirements for full requirements",
        },
        instagram: {
          endingCta: "Ending CTA",
          endingCtaDescription:
            'If you are posting a Reel, clearly state, "Check the link in bio!" depending on the features available.',
          caption: "Caption",
          captionDescription:
            'Use a concise and engaging caption with a strong call-to-action. E.g., : "Check the link in bio now! 🌟"',
          linkInBio: "Link in bio",
          linkInBioDescription:
            "The link should be placed at the top of bio. If you're using Linktree, position your promotional link directly above Linktree or add it as the first link within Linktree to ensure it's easily accessible.",
          headProvidedLink: "Aha-Provided Link",
          headProvidedLinkText:
            "Use the promotional link provided by Aha, not the official website link or a redirected link.",
          platformRequirements:
            "Check platform requirements for full requirements",
        },
        linkedin: {
          endingCta: "Ending CTA",
          endingCtaDescription:
            'If you are posting with a video, integrate a clear verbal or text-based CTA within the video, such as "Visit the link in my post for more info."',
          caption: "Caption",
          captionDescription:
            'Post with a strong CTA in the caption, like: "Check out more: {link}🌟"',
          headProvidedLink: "Aha-Provided Link",
          headProvidedLinkText:
            "Use the promotional link provided by Aha, not the official website link or a redirected link.",
          platformRequirements:
            "Check platform requirements for full requirements",
        },
      },

      // 标题配置
      titles: {
        aiAgents: "What AI agents will do next",
        collaborateConfidently:
          "Collaborate confidently with outcome guarantee",
        noResultsNoPayment: "No results, No Payment",
        deliveryRequirements: "How agents require influencers to deliver",
      },
    },
  },

  // AgentModal 组件
  agentModal: {
    header: {
      setupHeadDna: "Set up Aha's DNA",
      skip: "Skip",
      brandImageSetup: "Brand Image Setup",
      toneOfVoice: "Tone of Voice",
      brandIdentification: "Brand Identification",
    },
    dnaSuccess: {
      congratulations: "Congratulations!",
      completionMessage:
        "You have successfully completed the onboarding process.",
      continue: "Continue",
    },
    end: {
      congratulations: "Congratulations! Your brand DNA is locked and loaded.",
      description:
        "I'm genuinely excited to start creating marketing strategies and content that feel perfectly tailored to who you are. Let's see what we can achieve together!",
      startCampaign: "Start a great campaign",
      dailyTasks: "Do my daily tasks",
    },
    linkInput: {
      title: "Shape your Aha's DNA",
      description: "Enter your website or social media link",
      platforms: "(LinkedIn, X, TikTok, Instagram)",
      startNow: "Start now",
      validationError: "Please enter a valid website or social media link",
      sessionIdError: "Failed to get session id.",
      newConversation: "new conversation",
    },
    operationComponent: {
      goodResponse: "Good response",
      needImprovement: "Need improvement",
    },
    restComponent: {
      message: "Aha will continue to work after you reply.",
    },
    thinking: {
      message: "Thinking...",
    },
    toolsComponent: {
      campaignSettings: "Generate campaign settings for confirmation",
      audienceOptimization:
        "Based on the campaign information, generate the most optimized audiences to drive",
    },
  },
  // AhaCheck 组件
  ahaCheck: {
    recommended: "Recommended",
  },

  // AiAgent 组件
  aiAgent: {
    head: "Aha",
    hide: "Hide",
    showMore: "Show more",
  },

  // ApproveInfluencersEffortlesslyModal 组件
  approveInfluencersEffortlesslyModal: {
    autoApprovalEnabled:
      "Auto-approval enabled. Influencer applications will now be automatically approved based on your selected criteria.",
    checkSettings: "Check settings",
    notNow: "Not now",
    setupAutoApproval: "Set up auto-approval",
    approveInfluencersEffortlessly: "Approve influencers effortlessly",
    enableAutoApprovalDescription:
      "Enable auto-approval to automatically confirm influencer applications that meet your criteria—no need to review each one manually. You can update this setting anytime in your campaign information.",
    influencerAutoApproval: "Influencer auto-approval",
    saveSettings: "Save settings",
    matchingScoreOptional: "Matching score (optional)",
    matchingScoreAbove: "Matching score above",
    cpmBelowOptional: "CPM below (optional)",
    cpcBelowOptional: "CPC below (optional)",
    fillAllPlatformsError:
      "Please fill in the criteria for all platforms before submitting.",
    letAiPickTitle: "Let AI pick your influencers — boost results by 15%+",
    letAiPickDescription:
      "Backed by millions of collaborations, our AI Agent picks your best influencers — boosting results by 15%+ on average. Not satisfied? Report mismatches and get a refund anytime.",
    setRulesNext: "Set rules next",
    letAiAgentPickTitle: "Let our AI agent pick your influencers",
    aiAgentDescription:
      "Backed by millions of collaborations, our AI Agent picks your best influencers — boosting results by 15%+ on average. Not satisfied? Report mismatches and get a refund anytime.",
    aiAgentTitle: "AI Agent",
    aiAgentSubtitle:
      "Automatically confirms top-performing influencers based on pre-set criteria.",
    letAiHandleIt: "Let AI handle it",
    confirm: "Confirm",
    matchingScore: "Matching score (optional)",
    cpmBelow: "CPM below (optional)",
    cpcBelow: "CPC below (optional)",
    usd: "USD",
  },

  // ModalPaymentDetailAfter 组件
  modalPaymentDetailAfter: {
    paymentDetails: "Payment details",
    influencerPayment: "Influencer payment",
    aiMarketerCost: "AI employee cost",
    aiMarketerCostTooltip:
      "This helps us operate our platform and offer 24/7 customer support for your collaborations.",
    transactionFee: "Transaction fee",
    transactionFeeTooltip:
      "This fee is dependent on your payment method and charged by the payment service provider.",
    freeCredits: "Free credits",
    physicalProductSubsidy: "Physical product subsidy",
    physicalProductSubsidyDescription:
      "Aha helps subsidize influencer payments by deducting up to 60% of your product retail price.",
    total: "Total",
    paymentSecurityDescription:
      "Once you confirm the influencer, your payment will be securely held on the platform. You are entitled to a 100% refund if the influencer fails to deliver on time.",
    guaranteedSafePayment: "Guaranteed safe & secure payment",
    poweredBy: "Powered by",
  },

  // ModalRemoveCreatorAfter 组件
  modalRemoveCreatorAfter: {
    removeInfluencerConfirm: "Are you sure you want to remove this influencer?",
    highScoreDescription:
      "This influencer has a matching score over 80, indicating a top match for your campaign based on your current campaign setup.",
    refineCampaignDescription:
      "If the result doesn't meet your expectations, consider refining your campaign setup, especially:",
    coreSellingPoints: "Core selling points",
    coreAudiences: "Core product audiences",
    businessIntroduction: "Business introduction",
    goBack: "Go back",
    editCampaign: "Edit campaign",
    rejectAnyway: "Reject anyway",
    removeCreatorConfirm: "Remove this creator?",
    removeCreatorConfirmDescription: "Your input helps us understand your preferences and recommend influencers that are a better fit. Even a brief note can improve the accuracy of future matches.",
    remove: "Remove",
    specifyReason: "Please specify the reason",
    removeFailed: "Remove failed, please contact support.",
    removeSuccess: "Remove success",
    removeOptions: {
      audienceMismatch: "Audience mismatch",
      tooExpensive: "Too expensive",
      wrongAudienceLocation: "Wrong audience location",
      engagementLooksFake: "Engagement looks fake",
      contentNotRelevant: "Content not relevant",
      postingTooInfrequently: "Posting too infrequently",
      viewsTooLow: "Views too low",
      other: "Other",
    },
  },

  // AudienceSample 组件
  audienceSample: {
    useSampleAsGuide: "Use sample as guide",
    entrepreneursTitle: "Entrepreneurs Launching New Product Lines:",
    entrepreneursDescription:
      "Entrepreneurs introducing new products to the market need effective marketing strategies to gain traction. Aha's brand identity generation and automated marketing management provide them with the tools to establish a strong brand presence and execute targeted campaigns that drive initial sales and brand recognition.",
    clearInputsTip: "Clear and detailed inputs improve influencer matches",
  },

  // CampaignCard 组件
  campaignCard: {
    successfully: "successfully",
    deleteCampaignTitle: "Delete the campaign?",
    deleteCampaignContent:
      "Once you delete the campaign, this campaign will disappear from your campaign dashboard.",
    delete: "Delete",
    resumeCampaignTitle: "Resume the campaign?",
    resumeCampaignContent:
      "Once you resume the campaign, Jordan will begin sending new invitations, and all ongoing negotiations will continue.",
    resumed: "Resumed",
    resume: "Resume",
    pause: "Pause",
    edit: "Edit",
    editAndRelease: "Edit & release",
    paused: "Paused",
    duplicate: "Duplicate",
    trendCampaign: "Trend campaign",
  },

  // CampaignMarketingStrategyTag 组件
  campaignMarketingStrategyTag: {
    affiliateMarketing: "Affiliate marketing",
    influencerMarketing: "Influencer marketing",
  },

  // ChargeModal 组件
  chargeModal: {
    extraAdCredits: "Extra ad credits on every top-up",
    refundAvailable: "100% refund available anytime",
    priorityAccess: "Priority access to top influencer matching",
    vipSupport: "VIP support with dedicated responses",
    limitedTimeOffer: "Limited-time offer ends in",
    depositFunds: "Deposit funds",
    poweredBy: "Powered by",
    extraAdCreditsLabel: "Extra ad credits",
    failedToGetPaymentAddress: "Failed to get payment address.",
    addAtLeast: "Add at least",
    accountBalanceCover:
      "so that your account balance can cover this campaign's budget along with any remaining unspent budgets of your active campaigns.",
    pleaseAddAtLeast: "Please add at least",
    soYourAccountBalance:
      "so your account balance can cover this campaign's budget along with any remaining unspent budgets of your active campaigns.",
    allMajorCards: "All major credit and debit cards are supported. For",
    alternativePaymentMethods:
      "alternative payment methods such as bank transfer",
    bankTransfer: "bank transfer",
    pleaseContact: "please contact",
    byProceeding: "By proceeding, you agree to our",
    termsOfService: "Terms of Service and Refund Policy.",
    currency: "USD",
    placeholder: "$0",
    tooltipMessage:
      "Add at least {amount} so that your account balance can cover this campaign's budget along with any remaining unspent budgets of your active campaigns.",
    alertMessage:
      "Please add at least {amount} so your account balance can cover this campaign's budget along with any remaining unspent budgets of your active campaigns.",
    title: "Deposit funds",
    availableBalance: "Available balance",
    securePayment: "Secure Payment",
    onlinePayment: "Online Payment",
    bankTransfer1: "Bank Transfer",
    copied: "Copied",
    pleaseAddWorkSpace: "Please ensure to add",
    workSpaceName: "(workspace name)",
    toTheNotes:
      "to the notes for proper allocation. After the transfer arrives (you will be notified by email), you can create a campaign. Any bank transfer fees are covered by the advertiser, and Aha will credit the exact amount received. ",
    accountName: "Account name:",
    bankAccountNumber: "Bank account number:",
    achRoutingNumber: "ACH routing number:",
    fedwireRoutingNumber: "Fedwire routing number:",
    swiftCode: "SWIFT code:",
    bankName: "Bank name:",
    accountLocation: "Account location:",
    companyAddress: "Company Address:",
    bankAddress: "Bank address:",
    accountNo: "Account No:",
    abaRouting: "ABA Routing:",
    swiftCodeCapitalized: "Swift Code:",
    bankAddressCapitalized: "Bank Address:",
    copyAll: "Copy All",
    estimatedArrivalTimesMessage:
      "Estimated arrival times are: ACH (0–2 business days), Fedwire (0–1 business day), and SWIFT (1–3 business days, up to 3–5 in some regions).",
    forDepositDetails: "For deposit details, please refer to",
    topUpCampaignBudgetGuide: "Top-Up & Campaign Budget Guide.",
  },

  // ChatBotSubscribeModal 组件
  chatBotSubscribeModal: {
    upgradeYourPlan: "Upgrade your plan",
    plans: {
      free: {
        description: "Ideal for personal users just starting to explore Aha",
        items: {
          tasks: "4 tasks",
          unlimitedSeats: "Unlimited seats",
          dailyContentGeneration: "Daily content generation",
          viralCreativeIdeaGeneration: "Viral creative idea generation",
          competitorAndMarketInsights: "Competitor and market insights",
        },
      },
      starter: {
        description:
          "Perfect for hobbyists and casual users seeking light usage",
        items: {
          tasks: "10 tasks",
          unlimitedSeats: "Unlimited seats",
          dailyContentGeneration: "Daily content generation",
          viralCreativeIdeaGeneration: "Viral creative idea generation",
          competitorAndMarketInsights: "Competitor and market insights",
        },
      },
      pro: {
        description:
          "Tailored for professionals utilizing Aha several times weekly",
        items: {
          tasks: "40 tasks",
          unlimitedSeats: "Unlimited seats",
          dailyContentGeneration: "Daily content generation",
          viralCreativeIdeaGeneration: "Viral creative idea generation",
          competitorAndMarketInsights: "Competitor and market insights",
        },
      },
      max: {
        description: "Best for power users relying on Aha for continuous use",
        items: {
          tasks: "150 tasks",
          unlimitedSeats: "Unlimited seats",
          dailyContentGeneration: "Daily content generation",
          viralCreativeIdeaGeneration: "Viral creative idea generation",
          competitorAndMarketInsights: "Competitor and market insights",
        },
      },
    },
    downgradeReasons: {
      tooExpensive: "Too expensive for my current needs",
      notUsingFeatures: "Not using the premium features enough",
      notMeetExpectations: "The product doesn't meet my expectations",
      foundAlternative: "I found a better alternative",
      otherReasons: "Other reasons",
    },
    // DowngradeConfirmModal 相关文本
    downgradeModal: {
      switchTo: "Switch to",
      plan: "Plan",
      youAreDowngradingTo: "You are downgrading to",
      willLoseAccess:
        "You will lose access to the following features upon downgrading:",
      maybeLater: "Maybe later",
      successToDowngrade: "Success to downgrade",
      currentPlanExpire: "Your current plan will expire on",
      somethingWeCouldDoBetter:
        "Is there something we could do better? Let us know why you're downgrading.",
      letUsKnowHowToImprove: "Let us know how to improve",
      otherReasonsText: "Other reasons",
    },
    // PlanItem 相关文本
    planItem: {
      yearly: "YEARLY",
      perYear: "/year",
      perMonth: "/month",
      youAreOnThisPlan: "You are on this plan",
      youAreOnThisPlanWithEmoji: "You are on this plan 🎉",
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      successToUpgrade: "Success to upgrade",
    },
  },

  // ContactUs 组件相关文本
  contactUs: {
    discord: "Discord",
    joinImmediately: "Join immediately",
    email: "Email",
    contactSupport: "Contact support",
    bookAMeeting: "Book a meeting",
    contactHumanExpert: "Contact human expert",
  },

  // CoreAudiencesForm 组件相关文本
  coreAudiencesForm: {
    audienceDefinitionsCritical:
      "Your audience definitions are critical — they directly impact which influencers are matched for your campaign. The more specific and accurate your audience is, the better the matches you'll receive.",
    viewExamples: "View examples",
    number: "Number",
    title: "Title & Description",
    audiencesPrefilledInfo:
      "These audiences are pre-filled by Aha based on your campaign. Please review and refine as needed.",
    pleaseEnterAudienceName: "Please enter audience name",
    enterTitle: "Enter title",
    pleaseEnterAudienceDescription: "Please enter audience description",
    enterDescription: "Enter description",
    add: "Add",
    examples: {
      startupFounders: {
        title: "Startup founders looking to automate marketing efforts",
        description:
          "Entrepreneurs with limited resources need cost‑effective marketing solutions. Aha's AI agent–driven end‑to‑end campaign management enables them to run professional, multi‑channel campaigns without large teams—accelerating growth while keeping overhead low.",
      },
      enterprises: {
        title:
          "Enterprises seeking scalable, continuously optimized marketing results",
        description:
          "Large companies need marketing operations that scale fast and constantly improve. Aha's enterprise-grade AI platform automates campaign creation and testing across multiple channels, continuously analyzes performance, and optimizes strategies. This enables marketing teams to drive consistent growth while keeping up with complex markets and large customer bases.",
      },
      agencies: {
        title: "Agencies scaling content and client services",
        description:
          "Agencies need to deliver high-quality content and strategy at scale for multiple clients. Aha's collaborative AI platform speeds up influencer content generation, ideation, and reporting, allowing agencies to increase output, serve more clients, and maintain quality without expanding headcount.",
      },
    },
  },

  // CoreSellingPointsForm 组件相关文本
  coreSellingPointsForm: {
    number: "Number",
    description: "Description",
    pleaseInputCoreProductFeatures: "Please input core product features",
    pleaseInputInfluencerPersonas: "Please input desired influencer profiles",
    add: "Add",
  },

  // CreateEstimatePanel 组件相关文本
  createEstimatePanel: {
    views: "Views",
    cpm: "CPM",
    clicks: "Clicks",
    cpc: "CPC",
    usd: "USD",
    costPerInstallRange: "Cost per install range",
    installRange: "Install range",
    costPerLeadRange: "Cost per lead range",
    leadRange: "Lead range",
    costPerSignUpRange: "Cost per sign-up range",
    signUpRange: "Sign-up range",
    roiRange: "ROI range",
    salesRange: "Sales range",
    arpuCacRange: "ARPU/CAC range",
    aovCacRange: "AOV/CAC range",
    roi: "ROI",
  },

  // EstimatePanelNew 组件相关文本
  estimatePanelNew: {
    estimatedCampaignResults: "Estimated campaign results",
    affiliateMarketingResultsEstimation:
      "Affiliate marketing results estimation",
    coldEmailResultsEstimation: "Cold email results estimation",
    views: "Views",
    cpm: "CPM",
    clicks: "Clicks",
    cpc: "CPC",
    usd: "USD",
    costPerInstallRange: "Cost per install range",
    installRange: "Install range",
    costPerLeadRange: "Cost per lead range",
    leadRange: "Lead range",
    costPerSignUpRange: "Cost per sign-up range",
    signUpRange: "Sign-up range",
    roiRange: "ROI range",
    salesRange: "Sales range",
    arpuCacRange: "ARPU/CAC range",
    aovCacRange: "AOV/CAC range",
    roi: "ROI",
    cpmAcrossDifferentPlatforms: "CPM across different platforms",
    showLess: "Show less",
    viewAll: "View all",
    numberOfAffiliates: "Number of affiliates",
    noteSalesEstimates:
      "Note: Sales estimates are calculated using industry click-to-purchase conversion benchmarks ranging from 1.5% to 4.5%.",
    potentialConvertedLeads: "Potential converted leads",
    potentialCustomers: "Potential customers",
    potentialLifetimeRevenue: "Potential lifetime revenue",
  },

  // EstimatePanel 组件相关文本
  estimatePanel: {
    pendingStatus: {
      analyzingMessage:
        "Aha is currently analyzing your campaign information to generate predictions. This process may take up to one hour.",
    },
  },

  // GlobalAlert 组件相关文本
  globalAlert: {
    lowBudgetInfluencer: {
      title: "Your campaign {campaignName} is low on budget",
      desc: "Your budget directly limits how many influencers can be invited. Raise it today to unlock more collaborations and maximize your results.",
      confirmText: "Add budget",
      cancelText: "View campaign info",
    },
    campaignPaused: {
      title: "Your campaign {campaignName} has been paused due to inactivity.",
      desc: "To continue matching with influencers and keep things moving, you can resume the campaign now.",
      confirmText: "Resume campaign",
      cancelText: "View campaign info",
    },
    campaignApproved: {
      title: "Your Campaign Has Been Approved: {campaignName}",
      desc: "Your campaign has been successfully approved and is now live on the platform!",
      confirmText: "View campaign",
      cancelText: "Dismiss",
    },
    campaignRejected: {
      title: "Action Needed: Your campaign {campaignName} requires updates",
      desc: "We're currently unable to approve this campaign. Please review the feedback, make the necessary edits, and resubmit it for review.",
      confirmText: "View feedback",
      cancelText: "Dismiss",
    },
  },

  // HeadContainer 组件相关文本
  headContainer: {
    defaultTitle: "Your 24/7 AI employee for influencer marketing",
    analyzing: "Aha is analyzing...",
    working: "Aha is working...",
  },

  // HighQualityCard 组件相关文本
  highQualityCard: {
    header:
      "Aha is safeguarding your campaign success by selecting quality influencers",
    recentlyActive: {
      title: "Recently active",
      desc: "Posted content in the past {days} days",
    },
    highEngagementRate: {
      title: "High engagement rate",
      desc: "Engagement rate above Aha threshold",
    },
    performanceAuthenticity: {
      title: "Performance authenticity",
      desc: "No fake views or engagement detected",
    },
    goodCredit: {
      title: "Good credit",
      desc: "No breach of contract on Aha",
    },
  },

  modal: {
    changeBudget: {
      title: "Add budget",
      confirm: "Confirm",
      assistanceText: "If you need any assistance, don't hesitate to",
      contactUs: "contact us.",
      budgetUpdated: "Budget updated",
    },
  },

  // MatchInfluencerAdjustModal 组件
  matchInfluencerAdjustModal: {
    title: "Refine your campaign details to get better influencer matches",
    description:
      "Clear, detailed inputs help Aha match you with the most relevant influencers",
    businessIntroduction: "Business introduction",
    coreSellingPoints: "Core selling points",
    coreAudiences: "Core product audiences",
    introPlaceholder:
      "Please briefly describe your product's core value and unique points. Be concise and impactful.",
    introRequired: "Please enter elevator pitch",
    coreFeatureRequired: "please input core product features",
    add: "Add",
    titleLabel: "Title",
    descriptionLabel: "Description",
    titlePlaceholder: "Enter title",
    descriptionPlaceholder: "Enter description",
    audienceTitleRequired: "please input core audience title",
    audienceDescriptionRequired: "please input core audience description",
    cancel: "Cancel",
    updateButton: "Update to improve matches",
    successMessage:
      "We've updated influencer matching based on your inputs. Expect more influencers aligned with your latest campaign requirements.",
  },

  // MessageGuarantee 组件
  messageGuarantee: {
    organicTraffic: {
      title: "100% organic traffic",
      description: "Organic traffic to maximize results",
    },
    deliveryGuarantee: {
      title: "Delivery guarantee",
      description: "100% refund if influencers fail to deliver",
    },
    lowestPrice: {
      title: "Lowest price",
      description:
        "Lowest CPM and projected branded content views for optimal pricing",
    },
  },

  // DrawFeedback 组件
  drawFeedback: {
    // 按钮和标题
    provideFeedback: "Provide feedback",
    feedback: "Feedback",
    cancel: "Cancel",
    sendFeedback: "Send Feedback",

    // 标签页
    platformRequirements: "Platform requirements",
    brandRequirements: "Brand requirements",

    // 选项标题
    videoLength: "Video length",
    endingCTA: "Ending CTA",
    description: "Description",
    timestamp: "Timestamp",
    music: "Music",
    content: "Content",
    tweet: "Tweet",
    captions: "Captions",
    tagMention: "Tag & Mention",
    seamlessIntegration: "Seamless Integration",
    smoothTransitions: "Smooth Transitions",
    complementaryNarration: "Complementary Narration",
    consistentAesthetic: "Consistent Aesthetic",

    // 选项内容
    videoLengthContent: "Ensure the overall video length is at least 5 minutes",
    endingCTAContent: "Clearly state at the end of the video",
    descriptionContent:
      "Use a strong Call-to-Action for the advertiser/product",
    descriptionContent2: "Use the promotional link provided by Aha",
    timestampContent: "Create your timestamps",
    musicContent: "Check for copyright restrictions",
    endingCTAContent2:
      'Clearly state at the end of the video, "Check the link in the description for more info".',
    descriptionContent3:
      "Use a strong Call-to-Action for the advertiser/product at the beginning of description and the first pinned comment.",
    descriptionContent4:
      "Use the promotional link provided by Aha, not the official website link or a redirected link.",
    musicContent2:
      "Check for copyright restrictions in your background music, sound effects, and clips.",

    // TikTok 选项
    tiktokVideoLength:
      "Your video is under 30 seconds. Please extend it to between 30 seconds and 2 minutes.",
    tiktokContent:
      'The video lacks a clear verbal or text-based CTA. Please include "Visit the link in our tweet for more info and exclusive offers using coupon code."',
    tiktokTweet:
      'Your tweet starts weakly. Revise to "Check out our latest video to discover amazing deals! link".',
    tiktokTweet2:
      "Your tweet lacks relevant hashtags. Revise to add appropriate hashtags.",
    tiktokTweet3:
      "You tagged the product official account, which is not required. Please remove it.",

    // Instagram 选项
    instagramVideoLength:
      "The video length is less than 20 seconds. Please extend it to be longer than 20 seconds.",
    instagramEndingCTA:
      'The ending CTA "Check the link in bio!" is missing, and the coupon code is not displayed on-screen.',
    instagramCaptions:
      'Your caption is missing a strong Call-to-Action at the beginning. Please revise to include "Use code coupon code for XX% off! Visit the link in bio now!" and add relevant hashtags.',
    instagramCaptions2: "Your caption is missing relevant hashtags.",
    instagramTagMention:
      "You tagged the product official account, which is not required. Please remove it.",

    // Twitter/LinkedIn 选项
    twitterVideoLength:
      "Your video is under 30 seconds. Please extend it to between 30 seconds and 2 minutes.",
    twitterContent:
      'The video lacks a clear verbal or text-based CTA. Please include "Visit the link in our tweet for more info and exclusive offers using coupon code."',
    twitterTweet:
      'Your tweet starts weakly. Revise to "Check out our latest video to discover amazing deals! link".',
    twitterTweet2:
      "Your tweet lacks relevant hashtags. Revise to add appropriate hashtags.",
    twitterTweet3:
      "You tagged the product official account, which is not required. Please remove it.",

    // 物理产品选项
    physicalSeamlessIntegration:
      "Incorporate the provided video clips in appropriate segments of your video, ensuring they align with your usual video style and maintain authenticity for your audience.",
    physicalSmoothTransitions:
      "Create smooth transitions between the provided clips and your original footage, ensuring a cohesive and polished final video.",
    physicalComplementaryNarration:
      "Add narration, voiceover, or captions (if applicable) to explain or highlight the product's features in a way that complements the provided clips and engages your audience.",
    physicalConsistentAesthetic:
      "Match the lighting, tone, and style of the provided clips with your own footage to ensure the final video maintains a consistent aesthetic.",

    // 模态框
    feedbackLimitTitle: "You can submit feedback up to 4 times",
    feedbackLimitContent:
      "Please submit all feedback in advance to ensure the creator can deliver content promptly and maintain smooth collaboration.",
    gotIt: "Got it",

    // 通知消息
    approved: "approved!",
    feedbackSubmitted: "Feedback submitted successfully!",
    creatorWillProvide:
      "This creator will provide the revised draft. After this creator uploads draft, please review it timely and professionally",
    creatorWillProvideFirst:
      "This creator will provide the first video draft. After this creator uploads the first draft, please review it timeline and professional.",
    creatorWillProvideBefore:
      "The influencer will provide a revised draft before {dateTime}. To ensure an efficient and successful collaboration, please review promptly.",
    creatorWillPublish:
      "This creator will publish the content before {dateTime}. Stay tuned!",
  },

  // ModalSetUpCampaignData 组件
  modalSetUpCampaignData: {
    // 按钮文本
    notNow: "Not now",
    confirmChange: "Confirm change",
    ok: "OK",

    // 标题和描述
    head: "Aha",
    campaignEdited: "Campaign edited",

    // 邮件服务相关
    feelFreeToContact: "Feel free to contact us via: support@aha.inc",
    letMeKnow: "Let me know if there is anything else I can help. :)",

    // 表单字段标题
    locations: "Locations",
    placements: "Placements",
    languages: "Languages",
    coreSellingPoints: "Core selling points",
    customBrandGuidelines: "Custom brand guidelines",
    optimizedAudiences: "Optimized audiences",

    // 必填标记
    required: "*",

    // 工具提示
    locationsTooltip:
      "Choose a broad area to show your ads within can improve results.",
    placementsTooltip:
      "Choose the social platforms and content types you would like the influencers to engage with.",
    languagesTooltip:
      "Enter a language to show your ads to people who use the language.",
    coreSellingPointsTooltip:
      "Please indicate your content optimization preferences (such as the position of the traffic diversion button/label type), and we will send it to the creator.",

    // 表单验证消息
    selectAtLeastOneRegion: "Please select at least one region",
    selectAtLeastOnePlatform:
      "Please select at least one platform content type",
    selectedPlatformsLimitReach:
      "Selected platforms may limit your campaign's reach. To maximize performance, please consider including more platforms.",

    // 占位符
    selectAll: "Select All",
    platformContentTypePlaceholder:
      "Please select at least one platform content type",
    customGuidelinesPlaceholder: "e.g. Please use xxx features.",

    // 预算相关
    setYourMaximumCpm: "Set your maximum CPM manually",
    chooseYourBudgetLimit: "Choose your budget limit",
    setHighestBudgetPerInfluencer:
      "Set highest budget per influencer: Influencers above this budget limit will not be invited",
    setLowestBudgetPerInfluencer:
      "Set lowest budget per influencer: Influencers above this budget limit will not be invited",

    // 货币单位
    usd: "USD",

    // 添加/删除按钮
    add: "Add",

    // 最大数量限制
    maxCount: "20",
    mustDoMaxCount: "10",
  },

  // AffiliateNoRechargeModal 组件
  affiliateNoRechargeModal: {
    // 标题和称呼
    dearUser: "Dear User,",

    // 主要内容
    strategicAdjustment:
      "We'd like to inform you that, due to strategic adjustments, we will no longer offer Affiliate services.",
    changeNotAffect:
      "This change will not affect any ongoing collaborations or our Influencer Marketing services, which remain fully available. You're welcome to continue using our Influencer Marketing solutions.",
    contactForQuestions: "For any questions or assistance, please contact us:",
    email: "Email: ",
    supportEmail: "support@aha.inc",
    appreciation:
      "We appreciate your understanding and cooperation during this transition.",

    // 按钮
    gotIt: "Got it",
  },

  // SuggestionInput 组件
  suggestionInput: {
    additionalFeedback: "Additional feedback",
    addCustomizedFeedback: "Add customized feedback",
    delete: "Delete",
  },

  // ModalConfirmPrompt 组件
  modalConfirmPrompt: {
    title: "Content approved!",
    confirm: "Confirm",
    cancel: "Cancel",
    description:
      "Here are some tips to cut down communication time in future collaborations.",
    slides: {
      slide1: {
        title: "State your objective clearly",
        content:
          "This video should drive viewers to click the website link and sign up.",
      },
      slide2: {
        title: "Share a clear script suggestion / content outline",
        content:
          "Please include an unboxing and highlight our fast delivery service.",
      },
      slide3: {
        title: "Include references or brand tone guidelines",
        content:
          "We like the pacing of this TikTok video as a reference (+link).",
      },
      slide4: {
        title: "Clarify any prohibited or sensitive topics",
        content:
          "Please avoid mentioning any other brands, especially competitors.",
      },
      slide5: {
        title: "Specify your preferred tone and style",
        content: "We'd like the video to feel casual and vlog-style.",
      },
    },
  },
  icons: {},
  loading: {},
  tutorial: {},
  campaign: {},
  order: {},
  payment: {},
  notification: {},
  form: {},
  chart: {},
  table: {},
  card: {},
  button: {},
  input: {},
  select: {},
  alert: {},
  banner: {},
  sidebar: {},
  footer: {},
  header: {},
  content: {},
  wrapper: {},
  container: {},
  layout: {},
  grid: {},
  flex: {},
  text: {},
  image: {},
  video: {},
  audio: {},
  file: {},
  link: {},
  badge: {},
  tooltip: {},
  popover: {},
  dropdown: {},
  menu: {},
  breadcrumb: {},
  pagination: {},
  tabs: {},
  accordion: {},
  carousel: {},
  slider: {},
  progress: {},
  spinner: {},
  skeleton: {},
  empty: {},
  error: {},
  success: {},
  warning: {},
  info: {},
  modalAddOrderEnd: {
    title:
      "Scale your results by expanding campaign countries, languages, or social media platforms",
    okText: "Edit campaign",
    cancelText: "Not now",
    description:
      "Based on your current selections, we've already reached out to all matching influencers from our pool of over 50 million creators, but your campaign still has unused budget. To help you scale your results, consider",
    expandingText:
      " expanding into more countries, languages, or social media platforms ",
    reachBroaderAudience: "to reach a broader audience.",
    promptTitle: "Scale your results by expanding campaign selections",
    promptDescription:
      "You've reached all eligible influencers based on your current settings, but your campaign still has unused budget. To broaden your reach, try expanding <b>countries, languages, or platforms</b>, or adjust your <b>matching accuracy level</b> to discover more potential matches.",
    editCampaignButton: "Edit campaign",
    tutorialTitle: "Tutorial video",
  },
  modalAddPayment: {
    title: "Add payment information",
    cancel: "Cancel",
    next: "Next",
    topUpAmount: "Top up amount",
    addFunds: "Add funds",
    addFundsDesc:
      "With this setting, you prepay funds to the platform before you set up campaigns. Then, as your campaigns run and accrue costs, the funds on your balance will decrease.",
    addCard: "Add a card",
    addCardDesc:
      "You connect your cards with the platform and are automatically charged after your campaigns run.",
  },
  modalApprove: {
    approve: "Approve",
    confirmToApproveScript: "Confirm to approve script",
    approveContent: "Approve content",
    confirm: "Confirm",
    approveAndSendToInfluencer: "Approve and send to influencer",
    scriptApprovalNote:
      "Please note that once you approve the script, the influencer will begin the content production process.",
    contentApprovalNote:
      "Choose the expected publish time and leave any notes for the influencer. This helps ensure timely delivery and clear communication.",
    notes: "Notes",
    addNotesToInfluencer: "Add notes to the influencer",
    publishTime: "Publish time",
    publishTimeMessage: "Please set a publishing window longer than 24 hours.",
    addNotes: "Add notes",
    scriptApproved: "Script approved!",
    firstDraftMessage:
      "This creator will provide the first video draft before {dateTime}. After this creator uploads the first draft, please review it timeline and professional.",
    publishDeadlineMessage:
      "This creator will publish the content before {dateTime}. Stay tuned!",
    publishDeadlineAndNotesSent:
      "Publish deadline and notes sent to the influencer. They are expected to post on time.",
    approved: "approved!",
    cancel: "Cancel",
  },
  modalCompleteCollaboration: {
    completeCollaboration: "Complete collaboration",
  },
  modalCompleteCollaborationSuccess: {
    gotIt: "Got it",
    completeCollaboration: "Complete collaboration!",
    startTrackingMessage: "Start tracking campaign performance on Report tab!",
  },
  modalConfirmCreator: {
    paymentFailedTryAgain: "Payment failed, please try again.",
    paymentSuccessful: "Payment successful!",
    confirmAndPayFailed: "Confirm And Pay failed: {error}",
    confirmAndIncBudgetFailed: "Confirm And Inc Budget failed: {error}",
    confirmAndPay: "Confirm & Pay",
    confirm: "Confirm",
    cancel: "Cancel",
    campaignBudgetLimitReached: "Campaign Budget Limit Reached",
    budgetLimitWarning:
      "Just a heads-up—approving this influencer will put you over this campaign's budget.",
    wouldYouLikeToProceed: "Would you like to proceed?",
  },
  modalContentGuidance: {
    addCreativeDirectionOptional: "Add creative direction (optional)",
    addCreativeDirection: "Add creative direction",
    sharePreferencesMessage:
      "Share any preferences or examples to guide content creation for this influencer",
    creativeDirection: "Creative direction",
    submit: "Submit",
    creativeDirectionSuccessMessage:
      "Creative direction successfully shared with influencer",
    influencerMarketing: "Influencer Marketing",
    affiliateMarketing: "Affiliate Marketing",
  },
  modalDelayTwoDays: {
    postponeTimeline: "Postpone the timeline",
    maxPostponeTooltip:
      "You have reached the maximum amount of postponing your timeline. Contact support if you need further help.",
    areYouSureToPostpone: "Are you sure to postpone the timeline?",
    confirm: "Confirm",
    postponeNote:
      "Please note that for each campaign, you have up to 5 opportunities to postpone your timeline. Upon confirmation, you may extend the timeline by up to two business days for each postponement.",
    confirmSuccess: "Confirm success",
    confirmFailed: "Confirm failed",
  },
  modalFeedbackSuccess: {
    gotIt: "Got it",
    feedbackSubmittedSuccessfully: "Feedback submitted successfully!",
  },
  modalPauseReason: {
    pauseCampaignTitle: "Pause Campaign — Please let us know why?",
    helpUnderstandNeeds:
      "To help us better understand your needs and improve the platform experience, please select a reason for pausing this campaign",
    otherFeelFreeToShare: "Other — feel free to share",
    cancel: "Cancel",
    pauseCampaign: "Pause campaign",
    paused: "Paused",
    reasonTypes: {
      dontNeedToPromote: "Don't need to promote this product anymore",
      influencersTooExpensive: "Influencers are too expensive",
      influencersDontMatchBrand: "Influencers don't match my brand",
      alreadyFoundEnough: "Already found enough influencers elsewhere",
      performanceLowerThanExpected: "Performance was lower than expected",
    },
  },
  modalPaymentDetails: {
    confirm: "Confirm",
    paymentDetails: "Payment details",
    influencerPayment: "Influencer payment",
    recruitmentFee: "Recruitment fee",
    aiMarketerCost: "AI employee cost",
    aiMarketerCostTooltip:
      "This helps us operate our platform and offer 24/7 customer support for your collaborations.",
    transactionFee: "Transaction fee",
    transactionFeeTooltip:
      "This fee is dependent on your payment method and charged by the payment service provider.",
    freeCredits: "Free credits",
    physicalProductSubsidy: "Physical product subsidy",
    physicalProductSubsidyDescription:
      "Aha helps subsidize influencer payments by deducting up to 60% of your product retail price.",
    total: "Total",
    securePaymentNote:
      "Once you confirm the influencer, your payment will be securely held on the platform. You are entitled to a 100% refund if the influencer fails to deliver on time.",
    guaranteedSafeSecure: "Guaranteed safe & secure payment",
    poweredBy: "Powered by",
  },
  modalPaymentMoney: {
    next: "Next",
    failedToGetPaymentAddress: "Failed to get payment address.",
  },
  modalRechargeResult: {
    checking: "checking...",
    rechargeFailedTryAgain: "Recharge failed, please try again.",
    accountCreditedMessage: "{amount} USD has been added to your balance.",
    subscriptionSuccess: "Subscription success",
    subscriptionFailedTryAgain: "Subscription failed, please try again.",
    youreAllSet: "You're all set!",
    paymentMethodConfirmed:
      "Your payment method has been confirmed. We've now unlocked ",
    fullInfluencerOutreach: "full influencer outreach",
    forYourCampaign:
      " for your campaign — matching and invites are in progress.",
    gotIt: "View balance",
    topUpComplete: "Top-up successful",
    campaignDepositSuccessful: "Campaign deposit successful 🎉",
    campaignAlmostReadyActive:
      "Your campaign is almost ready to go. Click Update campaign to launch your latest changes.",
    campaignAlmostReady:
      "Your campaign is almost ready! Please finish any required business verification and authorization to officially launch your campaign.",
    updateCampaign: "Update campaign",
    completeSetup: "Complete setup",
  },
  modalRemoveCreator: {
    remove: "Remove",
    areYouSureToRemoveInfluencer:
      "Are you sure you want to remove this influencer?",
    highScoreMessage:
      "This influencer has a matching score over 80, indicating a top match for your campaign based on your current campaign setup.",
    considerRefiningMessage:
      "If the result doesn't meet your expectations, consider refining your campaign setup, especially:",
    coreSellingPoints: "Core selling points",
    coreAudiences: "Core product audiences",
    businessIntroduction: "Business introduction",
    goBack: "Go back",
    editCampaign: "Edit campaign",
    rejectAnyway: "Reject anyway",
    removeThisCreator: "Remove this creator?",
    removeButton: "Remove",
    pleaseSpecifyReason: "Please specify the reason",
    removeFailedContactSupport: "Remove failed, please contact support.",
    removeSuccess: "Remove success",
    creatorLanguageNotMeet:
      "Creator language does not meet the campaign requirement.",
    creatorAudienceNotMeet:
      "Creator's audience does not meet the campaign requirement",
    campaignBudgetFullyAllocated:
      "The campaign budget has been fully allocated.",
    creatorCoordinatedNetwork:
      "Creator is part of a coordinated network that frequently retweets, comments on, and likes each other's posts to artificially inflate engagement metrics.",
    other: "Other",
  },
  modalRemoveOrConfirm: {
    feedbackHelpsMatch:
      "Your feedback helps Aha match better influencers for you",
    goodNewsMessage:
      "Good news! Some influencers are interested in your campaign. Approve or remove them now so Aha can instantly refine influencer matches based on your feedback.",
    gotIt: "Got it",
  },
  modalShipInformation: {
    enterShippingInformation: "Enter shipping information",
    shippingInformation: "Shipping information",
    confirm: "Confirm",
    carrier: "Carrier",
    pleaseSelectCarrier: "Please select carrier",
    trackingNumber: "Tracking number",
    pleaseEnterTrackingNumber: "Please enter tracking number",
    weCantRetrieveYourShipmentDetailsRightNow:
      "We can’t retrieve your shipment details right now. Please confirm the tracking number. If correct, the delay may be due to data sync, and the status will update once available.",
    somethingWentWrongWhileLoadingLogisticsInfo:
      "Something went wrong while loading logistics info. Please try again later.",
  },
  modalUpdatePlan: {
    unknownError: "Unknown error",
    subscriptionCanceledSuccessfully: "Subscription canceled successfully",
    subscriptionDowngradedSuccessfully: "Subscription downgraded successfully",
    subscriptionUpgradedSuccessfully: "Subscription upgraded successfully",
    employmentPricingModelMessage:
      "Since you have selected the Employment Pricing Model, please purchase your plan now to launch your campaign.",
    campaignBudgetExceededMessage:
      "Your current campaign budget has exceeded your remaining influencer quota.",
    upgradePlanQuestion:
      "Would you like to upgrade your plan to {budget} and proceed with publishing this campaign?",
    chooseMonthlyBudgetMessage:
      "Choose your monthly influencer budget and then proceed to Stripe to complete your subscription.",
    selectUpgradePlanMessage:
      "Please select the plan you would like to upgrade to. The upgrade will take effect immediately.",
    confirmDowngradeMessage:
      "Please confirm that you would like to downgrade your plan. The change will take effect on {date}.",
    subscriptionCancelMessage:
      "Your current subscription will be canceled effective next month. Starting from next month, your pricing model will transition to Freelancing Model, and a 10% commission fee will be applied to each influencer collaboration you engage in.",
    selectCreatePlanMessage:
      "Please select the plan you would like to create. The change will take effect immediately.",
    defaultMessage:
      "Please select the subscription plan. If there may be any problems, please contact customer service.",
    purchase: "Purchase",
    downgradeSubscription: "Downgrade subscription",
    proceed: "Proceed",
    upgradeSubscription: "Upgrade subscription",
    notNow: "Not now",
    cancel: "Cancel",
    purchaseYourPlan: "Purchase your plan",
    downgradeSubscriptionPlan: "Downgrade your subscription plan?",
    cancelSubscriptionPlan: "Cancel your subscription plan?",
    upgradeYourSubscription: "Upgrade your subscription",
  },
  modalWarning: {
    affiliateIntegrationNeeded: "Affiliate integration needed",
    integrationMessage:
      "To ensure accurate tracking and timely commission payouts, please complete your affiliate integration as soon as possible following the steps outlined in our",
    affiliateIntegrationDocumentation: "Affiliate Integration Documentation.",
    continueSetup: "Continue setup",
  },
  stripeCardFormContent: {
    pleaseFillCompleteBillingAddress:
      "Please fill in the complete billing address information",
    cardBindingSuccessful: "Card binding successful.",
    errorDuringCardBinding:
      "An error occurred during card binding, please try again.",
    submit: "Submit",
  },
  terminateCollaboration: {
    cancelCollaboration: "Cancel collaboration",
    confirmation: "CONFIRMATION",
    cancel: "Cancel",
    notNow: "Not now",
    confirmCancellationOfCollaboration: "Confirm cancellation of collaboration",
    cancellationWarning:
      "Please note that cancelling the collaboration is irreversible. Please proceed with caution.",
  },
  notLikeFeedBackModal: {
    feedback: "Feedback",
    submit: "Submit",
    cancel: "Cancel",
    othersPlaceholder:
      "(Optional) Please share any comments or suggestions that you have to help us improve. We appreciate your feedback!",
  },
  orderStatusComponent: {
    lateProductionKickoff: "Late production kickoff",
    lateAddressSubmission: "Late address submission",
    lateSubmission: "Late submission",
    tooltipMessage:
      "This collaboration is eligible for cancellation and a 100% refund due to overdue delivery. You retain full rights to any generated UGC, even if you cancel because of delays.",
    slightlyBehindSchedule: "Slightly behind schedule",
    behindScheduleTooltip:
      "The influencer's submission is running a bit behind schedule, but our AI is proactively sending reminders to help keep everything on track.",
    // Order status labels
    collaborationEstablished: "Collaboration established",
    pendingProductionKickoff: "Pending production kickoff",
    pendingCreatorAddress: "Pending creator address",
    underScriptProduction: "Under script production",
    underScriptReview: "Under script review",
    underContentProduction: "Under content production",
    underContentReview: "Under content review",
    adsPendingPublish: "Ads pending publish",
    adsPublished: "Ads published",
    collaborationCancelled: "Collaboration cancelled",
    pendingProductShipment: "Pending product shipment",
    pendingProductArrival: "Pending product arrival",
    collaborationWithdrawn: "Collaboration withdrawn",
    expired: "Expired",
    pendingCreatorAccountInfo: "Pending creator account info",
    pendingAccountSetup: "Pending account setup",
  },
  paymentFailedAlert: {
    paymentFailed: "Payment failed",
    paymentFailedDescription:
      "We encountered an issue processing your payment, pausing your ongoing campaign(s). Please check your payment method and retry running your campaign. Contact support if you need assistance.",
    updatePaymentMethod: "Update payment method",
  },
  paymethodModal: {
    depositFundsNow: "Deposit funds now",
    addACard: "Add a card",
  },
  physicalProductInfo: {
    productName: "Product name",
    productRetailPrice: "Product retail price",
    productPhoto: "Product photo",
  },
  productLogo: {
    youCanOnlyUploadSvgFile: "You can only upload SVG file!",
    fileSizeCannotExceed10MB: "The file size cannot exceed 10MB!",
    failedToUploadLogo: "Failed to upload logo",
    upload: "Upload",
  },
  shareDialogue: {
    copySuccess: "copy success",
    copyFail: "copy fail",
    shareTemplate: "Share template",
    publicAccess: "Public access",
    anyoneWithThisLinkCanView: "Anyone with this link can view",
    share: "Share",
    copy: "Copy",
    copied: "Copied",
    shareMyTaskInTheOfficialUseCaseGallery:
      "Share my task in the official use case gallery",
  },
  submitHistory: {
    copiedAdAuthorizationCode: "Copied ad authorization code",
    appliedOn: "Applied on:",
    confirmedOn: "Confirmed on:",
    submittedOn: "Submitted on:",
    creativeDirection: "Creative direction",
    script: "Idea/Script ",
    video: "Video",
    draft: "Draft ",
    link: "link:",
    caption: "Caption:",
    adAuthorizationCode: "Ad authorization code:",
    videoDescription: "Video description:",
    draftDescription: "Draft description:",
    postCaptionDescription: "Post caption / description:",
    thumbnail: "Thumbnail:",
    influencersNote: "Influencer's note:",
    yourNote: "Your note:",
    requirements: "Requirements",
    additionalSuggestions: "Additional suggestions",
    creatorHasNotUploadedAnyContent: "The creator has not uploaded any content",
    contentPublishTime: "Content publish time:",
    influencerExpectedToSubmitFinalPostLink:
      "This influencer is expected to submit final post link within this period.",
    feedbackProvided: "Feedback provided",
    dealCanceled: "Deal canceled",
    underReview: "Under review",
    approved: "Approved",
    submitted: "Completed",
    skipped: "Skipped",
    skippedSystemText:
      "The creator has chosen to bypass the scriptwriting stage and proceed directly to video production.",
    rejected: "Rejected",
    cancelled: "Cancelled",
    timelineExtension: "Timeline extension",
    approve: "Approve",
    requestSubmittedAt: "Request submitted at",
    originalDeliveryDate: "Original delivery date",
    newDeliveryDate: "New delivery date",
    notesFromInfluencer: "Notes from influencer",
    rejectedReason: "Rejected reason",
    approveSuccess:
      "You have successfully approved the timeline extention! The influencer will be notified of the timeline update.",
    reviewIdeaScript: "Review idea/script",
    reviewDraft: "Review draft",
  },
  tableCreatorName: {
    influencerMatchedFromReference:
      "This influencer is matched from your reference influencers",
    following: "Following",
    estimatedViewsPost: "Estimated views/post",
    match: "match",
  },
  matchFromTag: {
    matchedFrom: "Matched from {brandName}",
  },
  timezone: {
    loading: "Loading...",
    timezoneSaved: "timezone saved!",
    timezoneSaveFailed: "timezone save failed!",
    save: "Save",
  },
  trackingApiKey: {
    apiKeysForTrackingMetrics: "API keys for tracking metrics",
    apiKeyManagement: "API Key Management",
    generateNewApiKey: "Generate New API Key",
    newApiKeyGenerated: "New API Key Generated",
    makeSureToCopyNow:
      "Make sure to copy this now. You won't be able to see it again.",
    activeApiKeys: "Active API Keys",
    loading: "Loading...",
    noActiveApiKeys: "No active API keys",
    created: "created:",
    revoke: "Revoke",
  },
  verifyInput: {
    pleaseEnterValidCode: "Please enter a valid code",
  },
  viewReportCard: {
    viewReport: "View report",
  },
  creatorTodoCard: {
    waiting: "Waiting",
    reviewTimelineExtension: "Review timeline extension",
    autoApprovedTooltip:
      "Request will be auto-approved 3 business days after it's submitted if there is no action taken.",
    overdueTooltip:
      "This request has been pending for over 30 days. Delayed feedback may affect the influencer’s schedule and increase the risk of ghosting. ",
    overdueTooltipLink: "Contact us for assistance.",
    overdue: "Needs attention",
  },
  yourCampaignCard: {
    reviewCollaboration: "Review collaboration",
    reviewDelivery: "Review delivery",
    reviewFinalPost: "Review final post",
    enterShippingInformation: "Enter shipping information",
    continueCampaign: "Continue campaign",
    reviewRequest: "Review request",
    confirmInviteList: "Review invite list",
    influencersReadyToBeInvited: "{count} influencers are ready to be invited",
    influencerAccessSetup: "Set up access"
  },
  adsOperateLab: {
    confirmCollaboration: "Confirm collaboration",
    approveDelivery: "Approve delivery",
    completeCollaboration: "Complete collaboration",
    shipProduct: "Ship product",
    influencerAccessSetup: "Influencer access setup"
  },
  timePassedComponent: {
    hasWaited: "Has waited",
    forConfirmation: "for confirmation",
    withdrawWarning:
      "Influencers are likely to withdraw applications when wait times exceed 5 business days.",
  },
  checkDepositModal: {
    title: "Deposit budget",
    desc: "Funds are securely held in third-party escrow and released only after influencer delivery is completed. For campaign deposit details, refer to",
    guide: "Top up and Campaign Budget Guide.",
    items: {
      payForResultsTitle: "Pay only for results",
      payForResultsDesc: "Guaranteed 100% refund if deliverables aren't met.",
      dualSidedContractTitle: "Dual-Sided contract protection",
      dualSidedContractDesc:
        "Every collaboration is secured by a legally binding contract.",
      verifiedTrafficTitle: "Verified real traffic",
      verifiedTrafficDesc:
        "All traffic and engagement are authenticated and fraud-free.",
    },
    caseStudy: "Case study",
    extraRights: "Trusted by world's leading AI native teams",
    rights: {
      repurpose:
        "Full rights to repurpose, edit, and reuse all influencer content.",
      runAds: "Full rights to run paid ads using influencer content.",
    },
    actions: {
      watchDemo: "Watch demo",
      contactSales: "Contact Sales",
      depositNow: "Deposit now",
    },
    howFundsFlow: {
      title: "How funds flow",
      description:
        "Every step is safeguarded by the platform to protect both brands and influencers.",
      steps: {
        deposit: "Deposit",
        launchCampaign: "Launch campaign",
        matchInfluencers: "Match influencers",
        confirmApplication: "Confirm Influencer application",
        fundsLocked: "(Funds locked in escrow)",
        delivery: "Delivery",
        fundsReleased: "Funds Released",
      },
    },
    depositNow: "Deposit now",
    depositItems: {
      budgetStoredTitle: "Budget Stored in Your Wallet",
      budgetStoredDesc:
        "Your budget is securely stored in your brand wallet to confirm campaign intent and will only be used once influencers deliver.",
      lockReleaseTitle: "Lock and Release Rules",
      lockReleaseDesc:
        "Funds are locked only after influencer confirmation and released 10 days after delivery is completed.",
      flexibleRefundsTitle: "Flexible Refunds",
      flexibleRefundsDesc:
        "Any unused funds can be refunded at any time — 100% guaranteed.",
      flexibleRefundsLink: "View refund policy",
      transparentPricingTitle: "Transparent Pricing",
      transparentPricingDesc:
        "No subscriptions, no hidden fees — you pay only for confirmed and delivered influencer content.",
      escrowProtectionTitle: "Escrow-backed Protection",
      escrowProtectionDesc:
        "Funds remain securely held in escrow until delivery, ensuring both parties are fully protected.",
    },
  },
  modalRejectPostpone: {
    reject: "Reject",
    letTheInfluenterKnowRejectReason:
      "Let the influenter know reject reason (optional)",
    rejectReason: "Reject reason",
    rejectSuccess:
      "You have successfully rejected the timeline extention! The influencer will be notified of the timeline update.",
    rejectFailed: "An error occurred! ",
  },
  TipPostponePending: {
    viewRequest: "View request",
    timelineExtension: "The influencer has requested a timeline extension",
    pleaseReviewAndProvideFeedback:
      "Please kindly review and provide feedback.",
  },
  rateModal: {
    title: "Rate the influencer",
    description:
      "Your feedback will be publicly visible and will directly impact the influencer's overall score, so please be fair and objective. Note that all reviews are submitted for moderation before they are published.",
    budgetConsumed: "Budget consumed",
    cancel: "Cancel",
    submitRating: "Submit rating",
    rating: "Rating",
    review: "Review",
    pleaseSelectRating: "Please select a rating",
  },
  reviews: {
    deleteRateDes:
      "Are you sure you want to delete this review? This action cannot be undone.",
    deleteRateTitle: "Delete review",
    noReviews: "No reviews",
    noReviewsDesc: "There are no reviews to show yet.",
    overdueHistory: 'Overdue history',
    overdueSteps: 'Overdue Steps',
    specifiedTime: 'Specified time',
    actualDeliveryTime: 'Actual delivery time',
    kickoffProduction: 'Kickoff production',
    submitAddress: 'Submit address',
    script: 'Submit idea/script',
    draft1: 'Submit content draft 1',
    draft2: 'Submit content draft 2',
    draft3: 'Submit content draft 3',
    draft4: 'Submit content draft 4',
    draft5: 'Submit content draft 5',
    finalLink: 'Submit final link',
    notYetDelivered: 'Not yet delivered',
  },

  // InvitesSendingModeForm 组件
  invitesSendingModeForm: {
    title: "Invites sending mode",
    description: "Choose whether Aha should send invites automatically or wait for your review",
    autoSend: {
      label: "Auto-send invites (recommended)",
      desc: "Aha sends invites as soon as influencers are matched for fastest outreach.",
    },
    reviewBeforeSending: {
      label: "Review before sending",
      desc: "You approve the influencer list before any invites are sent.",
    },
  },
  influencerUpgradeForm: {
    title: "Influencer access & credits",
    enableAccessAddCredits: "Enable access / add credits ",
    noAccessNeeded: "No access needed",
    validationMessage: "Please select influencer access & credits",
    informationRequiredLabel: "Information required from influencer",
    instructionLabel: "Instruction for influencer",
    informationRequiredValidation: "Please input information required from influencer",
    informationRequiredPlaceholder: "eg: Email, UID, Social handle",
    instructionPlaceholder: "Please provide your login email or UID (found in Profile → Account Info)",
    photos: "Submission reference",
  },
  confirmAccessSetupButton: {
    buttonText: "Confirm access setup",
  }
};
